'use strict'
import _ from 'lodash'
import moment from 'moment'
import scontrini from '@/services/scontriniService'
import prodotti from '@/services/prodottiService'
import magazzinoService from '@/services/magazzinoService'
import documenti from '@/services/documentiService'
import clienti from '@/services/clientiService'
import configurazioni from '@/services/configurazioniService'
import { v4 as uuidv4 } from 'uuid'

const numDecimali = 4

function arrotonda(valore) {
  const fattore = Math.pow(10, numDecimali)
  return Math.round((valore + Number.EPSILON) * fattore) / fattore
}

function round2Dec(value) {
  const fattore = Math.pow(10, numDecimali)
  return Math.round(value * fattore + Number.EPSILON) / fattore
}

/* var config, service
(async () => {
  const response = await fetch(process.env.BASE_URL + 'config.json')
  config = await response.json()
  service = config.service_comande || process.env.VUE_APP_service_comande
})() */

const sanitize = (value) => {
  try {
    var pattern = /[^a-zA-Z0-9-_]+/gi
    let sanate = value
    sanate = _.replace(String(sanate), ' ', '_')
    sanate = sanate.replace(pattern, '_').toLowerCase()
    return sanate
  } catch {
    return ''
  }
}

/* eslint-disable */
async function parseOrdineWH(message) {
  // TODO: Funzione specifica per cliente --> verificare come gestire i vari moduli. Va caricato dinamicamente (anche in fase di compilazione va bene...)
  const data = message.data

  // TODO: Separare i tracciati in base al chiamante ed inserire su DB.
  // TODO: Dovrebbe essere il server a fare il parsing dei dati prima di salvarli

  const piatti = data.piatti
  data.righe = []
  for (let p of piatti) {
    // Leggere i dati dal prodotto
    const prodotto = await prodotti.getProdotto(p.codice)
    let riga = {
      _id: _.get(prodotto, '_id') || p.codice,
      codice: _.get(prodotto, 'codice') || p.codice,
      descrizione: _.get(prodotto, 'descrizione') || p.piatto,
      quantita: p.quantita,
      magazzino: { unitaMisura: _.get(prodotto, 'magazzino.unitaMisura') || 'n' },
      aliquota: 10,
      tipo:  _.get(prodotto, 'tipoItem') || 'prodotto',
      tipoBene:  _.get(prodotto, 'tipoBene') || 'PRODOTTO',
      nota: p.note_piatto,
      repartoFiscale: '2',
      prezzoCliente: _.get(prodotto, 'prezzo.L1.base') || 0
    }
    if (p.variazioni) {
      riga.variazioni = []
      for (let v of p.variazioni) {
        const segno = v[0]
        let ingrediente = v.slice(2)
        let cod_ing = sanitize(ingrediente)
        const variazione = {
          segno: "+",
          codice: cod_ing,
          descrizione: ingrediente,
          deltaPrezzo: 0,
          deltaQuantita: 0,
          stampa: []
        }
        riga.variazioni.push(variazione)
      }      
    }
    if (p.det_menu) {
      const p1 = p.det_menu.piadina
      const p2 = p.det_menu.contorno
      const p3 = p.det_menu.bibita
      riga.menuComposto = [
        {gruppo1: {
          gruppo: 'Piadine',
          codice: sanitize(p1),
          nome: p1,
          variazioni:  []
        }},
        {gruppo2: {
          gruppo: 'Contorni',
          codice: sanitize(p2),
          nome: p2,
          variazioni:  []
        }},
        {gruppo3: {
          gruppo: 'Bevande',
          codice: sanitize(p3),
          nome: p3,
          variazioni:  []
        }}
      ]
      if (p1.variazioni) { // TODO: Verificare se possibile, dall'esempio non si capisce
        for (let v of p1.variazioni) {
          const segno = v[0]
          const ingrediente = v.slice(2)
          let cod_ing = sanitize(ingrediente)
          const variazione = {
            segno: "+",
            codice: cod_ing,
            descrizione: ingrediente,
            deltaPrezzo: 0,
            deltaQuantita: 0,
            stampa: []
          }
          riga.menuComposto.gruppo1.variazioni.push(variazione)
        }
      }
    }

    data.righe.push(riga)
  }
  // In questo caso ritorno direttamente il payload.
  // Verificare come gestire i codici dei piatti
  return data
/*   
  const item = {
    ordine: {},
    consegna: {},
    indirizzo: {},
    cliente: {},
    piatti: []
  }
  for (const els of Object.keys(data)) {
    const itm = data[els]
    if (itm['ordine']) {
      for (const el of itm['ordine']) {
        const chiave = Object.keys(el)[0]
        const value = el[chiave]
        item.ordine[chiave] = value
      }
    }
    if (itm['consegna']) {
      for (const el of itm['consegna']) {
        const chiave = Object.keys(el)[0]
        const value = el[chiave]
        item.consegna[chiave] = value
      }
    }
    if (itm['indirizzo']) {
      for (const el of itm['indirizzo']) {
        const chiave = Object.keys(el)[0]
        const value = el[chiave]
        item.indirizzo[chiave] = value
      }
    }
    if (itm['cliente']) {
      for (const el of itm['cliente']) {
        const chiave = Object.keys(el)[0]
        const value = el[chiave]
        item.cliente[chiave] = value
      }
    }
    if (itm['piatti']) {
      for (const el of itm['piatti']) {
        const piatto = {}
        for (const pp of el) {
          const chiave = Object.keys(pp)[0]
          const value = pp[chiave]
          piatto[chiave] = value
        }
        item.piatti.push(piatto)
      }
    }
  }
  return item */
}

async function parseOrdineWC(message, impoWoocommerce) {
  let data = message.data
  const docId = data.docId
  const documento = await documenti.getDocumento(docId)
  const ordineEc = documento.ordineEc
  const lineItems = ordineEc['line_items']
  data.dataOrdine = ordineEc.date_modified_gmt
  data.righe = []
  for (let l of lineItems) {
    // TODO: Verificare come costruire _id di un prodotto con varianti
    const productId = l.variation_id || l.product_id
    // const prodotto = await prodotti.getProdotto(productId)
    const prodotto = await prodotti.getProdottoEcommerce(true, productId)
    
    let riga = {
      _id: _.get(prodotto, '_id'),
      codice: _.get(prodotto, 'codice'),
      descrizione:  `${prodotto.descrizione} ${_.get(prodotto, 'varianti.variante1.descrizione', '')} ${_.get(prodotto, 'varianti.variante2.descrizione', '')}`.trim(),
      barcode: prodotto.ricercaBarcode,
      variante1: _.get(prodotto, 'varianti.variante1.codice', ''),
      variante2: _.get(prodotto, 'varianti.variante2.codice', ''),      
      quantita: l.quantity,
      magazzino: { unitaMisura: _.get(prodotto, 'magazzino.unitaMisura') || 'n' },
      aliquota: _.get(prodotto, 'datiFiscali.aliquoteIva[0].valore') || 22,
      aliquotaIva: _.get(prodotto, 'datiFiscali.aliquoteIva[0]'),
      tipo:  _.get(prodotto, 'tipoItem') || 'prodotto',
      tipoBene:  _.get(prodotto, 'tipoBene') || 'PRODOTTO',
      repartoFiscale: _.get(prodotto, 'datiFiscali.reparto.stampante') || '1',
      // prezzoCliente: l.price || _.get(prodotto, 'prezzo.L1.base') || 0,
      prezzoCliente: +((parseFloat(l.total || '0') + parseFloat(l.total_tax || '0'))/(l.quantity || 1)).toFixed(2) || _.get(prodotto, 'prezzo.L1.base') || 0,
      prezzoAcquisto: _.get(prodotto, 'magazzino.prezzoAcquisto', '')
    }
    riga.prezzoUnitario = +riga.prezzoCliente.toFixed(2)
    riga.prezzo = +(riga.prezzoCliente * riga.quantita).toFixed(2)
    data.righe.push(riga)
  }

  // TODO: Verificare se creare sempre un nuovo cliente (da impostazioni) o provare a recuperare esistente. E' legato alla presenza dell'archivio clienti su Woocommerce
  
  let nomeCliente = _.get(ordineEc, 'billing.billing_partitaiva', '') ? _.get(ordineEc, 'billing.billing_ragione_sociale', '') : ''
  nomeCliente = nomeCliente || `${_.get(ordineEc, 'billing.billing_nome', '')} ${_.get(ordineEc, 'billing.billing_cognome', '')}`
  nomeCliente = nomeCliente || `${_.get(ordineEc, 'billing.first_name', '')} ${_.get(ordineEc, 'billing.last_name', '')}`
  data.cliente = {
    codice: '',
    ragioneSociale: nomeCliente
  }
  data.dataConsegna = ordineEc.date_modified || ordineEc.date_created
  data.infoCliente = {
    billing: ordineEc.billing,
    shipping: ordineEc.shipping
  }

  let costoSpedizione = parseFloat(ordineEc.shipping_total || '0')
  // TODO: Prendere effettivo valore da eCommerce
  let ivaSpedizioni = _.get(impoWoocommerce, 'forzaIva', 22)
  if (ordineEc.prices_include_tax || _.get(impoWoocommerce, 'forzaIva') ) {
    data.costoSpedizione = +(costoSpedizione / ( 1 + (ivaSpedizioni/100))).toFixed(2)
  } else {
    data.costoSpedizione = costoSpedizione
  }
  data.totaleOrdine = +(parseFloat(ordineEc.total || '0') + parseFloat(ordineEc.total_tax || '0')).toFixed(2)

  return data
}

async function verificaClienteWC(infoCliente, creaSeMancante) {
  const { billing, shipping } = infoCliente
  const chiave = billing.billing_partitaiva || billing.billing_codfisc || billing.email //  billing.fiscalcode || billing.ivacode || billing.email // TODO: verificare se esistono e come si chiamano
  var cliente
  // TODO: Verificare. Probabilmente è necessario creare una fuinzione di ricerca clienti specifica
  const filtri = { testo: chiave }
  const opzioni = { itemsPerPage: 10, page: 1 }
  const esistente = await clienti.getFilteredCustomers(filtri, opzioni, 'v3')
  if (esistente.rows.length > 0) {
    const cliente = esistente.rows[0]
  }
  if (!cliente) {
    if (!creaSeMancante) {
      return null
    }
    let nuovoCliente = await clienti.getModello()
    nuovoCliente.ragioneSociale = billing.billing_ragione_sociale || `${billing.billing_nome || ''} ${billing.billing_cognome || ''}`.trim() || `${billing.first_name || ''} ${billing.last_name || ''}`.trim()
    nuovoCliente.codice = await clienti.creaCodiceCliente(nuovoCliente.ragioneSociale)
    nuovoCliente.amministrativi.cliente = true
    if (billing.billing_codfisc) {
      nuovoCliente.amministrativi.codiceFiscale = billing.billing_codfisc
    }
    if (billing.billing_partitaiva) {
      nuovoCliente.amministrativi.partitaIva = billing.billing_partitaiva
    }
    nuovoCliente.fatturazione = nuovoCliente.fatturazione || {}
    nuovoCliente.fatturazione.codiceSdi = billing.billing_codice_destinatario || ''
    nuovoCliente.fatturazione.pec = billing.billing_pec  || ''
    nuovoCliente.recapiti = []
    nuovoCliente.recapiti.push({
      codice: uuidv4(),
      tipo: {
        codice: 'principale',
        descrizione: 'Sede'
      },
      indirizzo: (billing.address_1 + ' ' + billing.address_2).trim(),
      localita: billing.city,
      cap: billing.postcode,
      provincia: billing.state,
      nomeProvincia: billing.city,
      nazione: billing.country,
      telefono: billing.phone,
      email: billing.email
    })
    nuovoCliente.recapiti.push({
      codice: uuidv4(),
      tipo: {
        codice: 'consegna',
        descrizione: 'Consegna',
        default: false,
        univoco: false        
      },
      regioneSociale: shipping.company || (shipping.first_name + ' ' + shipping.last_name).trim(),
      indirizzo: (shipping.address_1 + ' ' + shipping.address_2).trim(),
      localita: shipping.city,
      cap: shipping.postcode,
      provincia: shipping.state,
      nomeProvincia: shipping.city,
      nazione: shipping.country,
      telefono: shipping.phone,
      email: shipping.email
    })
    cliente = await clienti.creaCliente(nuovoCliente)
  }
  return cliente
}

async function inviaOrdinePark(impoWoocommerce, custom, postazione) {
  const pk = impoWoocommerce.parcheggio
  const posizione = await calcPosizione(pk.zona, pk.righe, pk.colonne)
  if (posizione) {
    let righe = []
    for (let p of custom.righe) {
      const riga = {
        codice: p._id,
        codiceProdotto: p.codice,
        barcode: p.ricercaBarcode,
        variante1: _.get(p, 'varianti.variante1.codice', ''),
        variante2: _.get(p, 'varianti.variante2.codice', ''),
        quantita: p.quantita,
        descrizione: `${p.descrizione} ${_.get(p, 'varianti.variante1.descrizione', '')} ${_.get(p, 'varianti.variante2.descrizione', '')}`.trim(),
        prezzoUnitario: +p.prezzoCliente.toFixed(2),
        prezzo: (p.prezzoCliente * p.quantita).toFixed(2),
        aliquota: _.get(p, 'datiFiscali.aliquoteIva[0].valore', ''),
        tipo: 'prodotto',
        tipoBene: 'PRODOTTO',
        repartoFiscale: _.get(p, 'datiFiscali.reparto.stampante', ''),
        prezzoAcquisto: _.get(p, 'magazzino.prezzoAcquisto', '')
      }
      if (p.menuComposto) {
        riga.menuComposto = p.menuComposto
      }
      righe.push(riga)
    }

    let prodottoSpedizione = _.get(pk, 'spese.spedizione', '')
    if (prodottoSpedizione) {
      const speseSpedizione = custom.costoSpedizione || 0
      if (speseSpedizione) {
        const p = await prodotti.getProdotto(prodottoSpedizione)
        const riga = {
          codice: p._id,
          codiceProdotto: p.codice,
          barcode: p.ricercaBarcode,
          variante1: _.get(p, 'varianti.variante1.codice', ''),
          variante2: _.get(p, 'varianti.variante2.codice', ''),
          quantita: p.quantita,
          descrizione: `${p.descrizione} ${_.get(p, 'varianti.variante1.descrizione', '')} ${_.get(p, 'varianti.variante2.descrizione', '')}`.trim(),
          prezzoUnitario: +speseSpedizione.toFixed(2),
          prezzo: +speseSpedizione.toFixed(2),
          aliquota: _.get(p, 'datiFiscali.aliquoteIva[0].valore', ''),
          tipo: 'prodotto',
          tipoBene: 'PRODOTTO',
          repartoFiscale: _.get(p, 'datiFiscali.reparto.stampante', ''),
          prezzoAcquisto: _.get(p, 'magazzino.prezzoAcquisto', '')
        }
        righe.push(riga)
      }
    }
    // TODO: Verificare contrassegno whook_duogel_2783 fee_lines  db nuovo

    let payload = {
      dataOrdine: new Date(),
      tipo: impoWoocommerce.tipo,
      cliente: {}
    }
    const docPar = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
    let codiceCliente = _.get(impoWoocommerce, 'ordine.cliente')
    var cliente
    if (codiceCliente) {
      cliente = await clienti.getCliente(codiceCliente)
    } else {
      cliente = await verificaClienteWC(custom.infoCliente, true)
    }

    payload = _.merge(payload, custom) // Verificare se necessario

    payload.cliente.codice = cliente.codice
    payload.cliente.ragioneSociale = cliente.ragioneSociale
    payload.note = `Totale: € ${custom.totaleOrdine.toFixed(2)} (di cui sped: € ${custom.costoSpedizione.toFixed(2)})`
    // const cliente = custom.infoCliente.billing.billing_ragione_sociale || `${custom.infoCliente.billing.billing_nome} ${custom.infoCliente.billing.billing_cognome}`.trim() || `${custom.infoCliente.billing.first_name} ${custom.infoCliente.billing.last_name}`.trim()
    const descZona = cliente.ragioneSociale + ' ' + ( _.get(custom, 'infoCliente.billing.phone') || _.get(custom, 'infoCliente.billing.email') || '')
    
    return await scontrini.creaScontrino({ righe }, { zona: String(pk.zona), posizione: posizione, payload: payload, descContenutoZona: descZona })
  } else {
    return null
  }
}

async function calcPosizione(zona, righe, colonne) {
  let posizioni = []
  for (let r = 1; r <= righe; r++) {
    for (let c = 1; c <= colonne; c++) {
      posizioni.push(`${zona}.${r}.${c}`)
    }
  }
  let parcheggiati = await scontrini.getParcheggiati()
  const occupati = parcheggiati.length > 0 ? parcheggiati.map(x => x.parcheggio.posizione) : []
  const liberi = _.difference(posizioni, occupati)
  return liberi.length > 0 ? liberi[0] : ''
}

// Crea un ordine che però impegna la giacenza (come DDT) ... attenzione se scontrino o fattura, non deve impegnare ulteriormente
async function wcCreaOrdineEC(impoWoocommerce, ordineWC, postazione) {
  const docPar = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
  const tipoDocumento = docPar.find(x => x.codice === (_.get(impoWoocommerce, 'ordine.tipoDocumento') || 'ordineClienteEC'))
  let codiceCliente = _.get(impoWoocommerce, 'ordine.cliente')
  var cliente
  if (codiceCliente) {
    cliente = await clienti.getCliente(codiceCliente)
  } else {
    // TODO: Completare. Nel caso non si utilizzi sempre lo stesso cliente per tutti gli ordini, va verificato se il cliente dell'ordine non esite e nel caso va creato
    // codiceCliente = 'cliente_ecommerce' // per adesso, poi creare o leggere da DB
    cliente = await verificaClienteWC(ordineWC.infoCliente, true)
  }
  const causaleMovimento = _.get(impoWoocommerce, 'ordine.causaleMovimento')
  const magazzino = _.get(impoWoocommerce, 'ordine.magazzino')
  const listino = _.get(impoWoocommerce, 'listino', { codice: 'L1', descrizione: 'Listino Base', ivato: true})
  const locDocumento = await documenti.getModello('xxx')
  locDocumento._id = await configurazioni.getNumeratore(tipoDocumento.codice, true)
  locDocumento.codice = locDocumento._id
  locDocumento.data = new Date()
  locDocumento.tipoDocumento = tipoDocumento
  locDocumento.anagrafica = {
    cliente: {
      codice: cliente.codice,
      descrizione: cliente.ragioneSociale,
      amministrativi: cliente.amministrativi,
      fatturazione: cliente.fatturazione
    }
  }
  locDocumento.pagamento = {
    dettaglio: {
      modalita: 'MP08',
      descrizione: 'Carta di pagamento'
    },
    infoBanca: null,
    codiceXml: 'MP08',
    condizioni: 'TP02'
  }
  const spedizione = cliente.recapiti.length > 0 ? cliente.recapiti.find(x => x.tipo.codice === 'consegna') || cliente.recapiti.find(x => x.tipo.codice === 'principale') : {}
  _.set(locDocumento, 'spedizione.destinazione', spedizione)
  
  locDocumento.righe = []
  for (let r of ordineWC.righe) {
    let riga = {
      rigaDescrittiva: false,
      descrizione: r.descrizione,
      quantita: r.quantita,
      unitaMisura: r.magazzino.unitaMisura,
      listino: null,
      aliquota: null,
      prezzi: null,
      sconti: null,
      importi: null,
      valore: {
        listino: listino,
/*         listino: {
          codice: 'L1',
          descrizione: 'Listino Base',
          ivato: true
        }, */
        sconto1: 0,
        sconto2: 0,
        sconto3: 0,    
        prezzoUnitario: r.prezzoUnitario,
      },
      prodotto: {
        codice: r.codice
      },
      // codiceRiga: ,
      tipoBene: r.tipoBene,
      repartoFiscale: r.repartoFiscale,
      aliquotaIva: r.aliquotaIva
    }

    const pl = riga.valore.prezzoUnitario
    const qta = riga.quantita
    const aliquota = riga.aliquotaIva.valore
    const sconto = 1
    riga.valore.prezzoUnitario = pl ? round2Dec(pl) : 0
    riga.valore.prezzoTotale = qta && pl ? +(qta * parseFloat(riga.valore.prezzoUnitario)).toFixed(numDecimali) : 0
    riga.valore.prezzoNettoUnitario = pl ? round2Dec(pl / ( 1 + aliquota / 100)): 0
    riga.valore.prezzoNettoTotale = qta && pl ? +(qta * parseFloat(riga.valore.prezzoNettoUnitario)).toFixed(numDecimali) : 0
    riga.valore.prezzoUnitario = pl ? riga.valore.prezzoUnitario.toFixed(numDecimali) : 0
    riga.valore.prezzoNettoUnitario = pl ? +riga.valore.prezzoNettoUnitario.toFixed(numDecimali) : 0

    riga.valore.importoUnitario = pl ? round2Dec(pl * sconto) : 0
    riga.valore.importoTotale = qta && pl ? +(qta * parseFloat(riga.valore.importoUnitario)).toFixed(numDecimali) : 0
    riga.valore.importoNettoUnitario = pl ? round2Dec((pl / ( 1 + aliquota / 100)) * sconto) : 0
    riga.valore.importoNettoTotale = qta && pl ? +(qta * parseFloat(riga.valore.importoNettoUnitario)).toFixed(numDecimali) : 0
    riga.valore.importoUnitario = pl ? +riga.valore.importoUnitario.toFixed(numDecimali) : 0
    riga.valore.importoNettoUnitario = pl ? +riga.valore.importoNettoUnitario.toFixed(numDecimali) : 0

    locDocumento.righe.push(riga)
  }

  let speseSpedizione = _.get(impoWoocommerce, 'ordine.spese', null)
  if (speseSpedizione) {
    speseSpedizione.valore = ordineWC.costoSpedizione || 0
    _.set(locDocumento, `spese`, speseSpedizione)
  }

  await completaDocumento(locDocumento)
  const documento = await documenti.creaDocumento(locDocumento)
  
  // TODO: Verificare. In base alle impostazioni deve creare anche i movimenti per aggiornare la giacenza
  await acquisto(ordineWC.righe, causaleMovimento, magazzino, `ordiceEC: ${ordineWC.id}`, ordineWC.dataOrdine)
}

const acquisto = async function(righeCarrello, causaleMovimento, magazzino, riferimento, data) {
  const causali = await configurazioni.getConfigurazione('magazzino_causali', 'causali')
  const causale = causali.find(el => el.codice === causaleMovimento)
  const base = {
    magazzino: magazzino || 'mag01',
    tipoCausale: causale.tipo,
    causale: causale.codice,
    data: data || new Date(),
    riferimento: riferimento || causaleMovimento,
    mostraCliente: causale.visualizzaCliente,
    mostraFornitore: causale.visualizzaFornitore,
    tipoPrezzo: causale.tipoPrezzo
  }
  const movimentiMultipli = await buildMovimentiMultipli(righeCarrello, base)
  await magazzinoService.creaMovimentiMultipli(movimentiMultipli)
}

const buildMovimentiMultipli = async function(righeCarrello, base) {
  const prodottiInseriti = righeCarrello
  const ids = prodottiInseriti.map(x => x.codice)
  var elencoProdotti = await prodotti.getProdottiByIds(ids)
  const movimenti = elencoProdotti.map(el => {
    const quantita = prodottiInseriti.find(x => x.codice === el._id).quantita
    const nM = {
      magazzino: base.magazzino,
      tipo: base.tipoCausale,
      causale: base.causale,
      data: base.data,
      prodotto: {
        codice: el._id,
        um: _.get(el, 'magazzino.unitaMisura', '')
      },
      anagrafica: {},
      riferimento: {
        tipo: 'ordineECommerce',
        id: base.riferimento,
        data: base.data
      }
    }
    if (base.mostraCliente && base.nominativo) {
      nM.anagrafica.cliente = {
        codice: base.nominativo,
        descrizione: base.nominativoDescrizione
      }
    }
    if (base.mostraFornitore && base.nominativo) {
      nM.anagrafica.fornitore = {
        codice: base.nominativo,
        descrizione: base.nominativoDescrizione
      }
    }

    nM.quantita = +parseFloat(quantita).toFixed(2)
    if (base.tipoPrezzo === 'acquisto') {
      nM.valore = +parseFloat(_.get(el, 'magazzino.prezzoAcquisto', 0)).toFixed(2)
    } else {
      nM.valore = +parseFloat(_.get(el, 'prezzo.L1.base', 0)).toFixed(2)
    }

    return nM
  })
  return movimenti
}

const completaDocumento = async function(locDocumento) {
  let repartiFiscali = await configurazioni.getConfigurazione('prodotti_reparti_fiscali', 'reparti')
  const aliquote = await configurazioni.getConfigurazione('prodotti_aliquote_iva', 'aliquote')
  repartiFiscali = repartiFiscali.map(x => {
    const iva = aliquote.find(al => al.codice === x.codiceIva)
    if (iva) {
      return {
        repartoFiscale: x.stampante.numero,
        tipoBene: x.descrizione,
        descrizione: 'Iva: ' + iva.descrizione,
        aliquota: iva.aliquota
      }
    } else {
      return {
        repartoFiscale: x.stampante.numero,
        tipoBene: x.descrizione,
        descrizione: 'Iva: non definita',
        aliquota: 0
      }
    }
  })
  const tRepartiFiscali = _.uniqBy(repartiFiscali, 'repartoFiscale')	  
  const doc_pagamenti = await configurazioni.getConfigurazione('documenti_pagamento')

  const modalitaPagamento = doc_pagamenti.modalitaPagamento
  const condizioniPagamento = doc_pagamenti.condizioniPagamento
  const speseFattura = doc_pagamenti.spese
  const banche = doc_pagamenti.banche

  //TODO: Ripresa gestione documenti. Su moleculer implementare una sola volta su server !!!
  await calcolaDatiFooter(locDocumento, modalitaPagamento, condizioniPagamento, speseFattura, tRepartiFiscali, banche)
}

const calcolaDatiFooter = async function(locDocumento, tModalitaPagamento, tCondizioniPagamento, tSpeseFattura, tRepartiFiscali, tBanche) {
  var totali = {}
  const clifor = _.get(locDocumento, 'anagrafica.cliente', null)
  if (!clifor || locDocumento.righe.length === 0) return
  const mp = _.get(locDocumento, 'pagamento.dettaglio.modalita') || _.get(locDocumento, 'pagamento.modalita.codice')
  var banca, modalitaPagamento
  if (mp) {
    modalitaPagamento = tModalitaPagamento.find(x => x.codice === mp)
    const modalitaSelezionata = modalitaPagamento
    banca = modalitaPagamento.infoBanca ? tBanche.find(x => x.codice === modalitaPagamento.infoBanca)  : null

    const bancaAppoggio = banca
    locDocumento.pagamento.infoBanca = banca
    locDocumento.pagamento.codiceXml = modalitaPagamento.codiceXml
  }
  const cd = locDocumento.pagamento.condizioni
  const condizioniPagamento = tCondizioniPagamento.find(x => x.codice === cd)
  const codizioniSelezionate = condizioniPagamento
  let speseFattura = tSpeseFattura || []
  if (locDocumento.spese) {
    speseFattura = speseFattura.filter(x => x.codice !== locDocumento.spese.codice)
    speseFattura.push(locDocumento.spese)
  }
  // const speseFattura = locDocumento.spese || clifor.fatturazione.spese || tSpeseFattura || []
  let valori = calcolaValoriDocumento(locDocumento, tRepartiFiscali)
  if (valori.length === 0) return
  const scontoInFattura = locDocumento.scontoFattura || 0
  
  const totImpo = _.sumBy(valori, (el) => { return el.importoNettoTotale })
  const totaleMerce = totImpo - scontoInFattura // Si parte dalla somma dei prodotti meno lo sconto in fattura
  const { spese, totaleSpese } = calcolaSpese(speseFattura, totaleMerce)
/*   for (let s of spese) {
    this.inputSpesa = this.inputSpesa || {}
    this.inputSpesa[s.codice] = s.valore
  } */


  totali = calcolaTotaliAliquote_v2(totali, valori, spese, scontoInFattura, totaleMerce)

  const totaleCompleti = totali
  const scadenze = calcolaScadenze(totaleCompleti, modalitaPagamento)

  locDocumento.totali = totaleCompleti
  locDocumento.scadenze = scadenze
  if (scadenze.length > 1) {
    locDocumento.pagamento.condizioni = 'TP01'
  }
  locDocumento.spese = spese
  locDocumento.spedizione = locDocumento.spedizione || {}
  locDocumento.spedizione.dataRitiro = moment().format('YYYY-MM-DD')
  locDocumento.spedizione.oraRitiro = moment().format('HH:mm')
}

function calcolaTotaliAliquote_v2(totali, valori, spese, scontoInFattura, totaleMerce) {
  const sconto = parseFloat(scontoInFattura || 0)
  const totImpo = _.sumBy(valori, (el) => { return el.importoNettoTotale })
  const speseNd = spese.filter(x => !x.documentate)
  const speseD = spese.filter(x => x.documentate)
  const totSpeseNd = _.sumBy(speseNd, (el) => +parseFloat(el.valore).toFixed(numDecimali)) || 0
  const totSpeseD = _.sumBy(speseD, (el) => +parseFloat(el.valore).toFixed(numDecimali)) || 0
  const cr = totaleMerce !== 0 ? totSpeseNd / totaleMerce : 1
  // Lo sconto agisce sull'imponibile, ma devo ripartirlo in percentuale perchè le varie voci sono separate per aliquota 
  const scontoPerc = totImpo !== 0 ? (totImpo - (totImpo - sconto)) / totImpo : 0
  for (let v of valori) {
    // totali[`iva_${v.aliquota}`] = totali[`iva_${v.aliquota}`] || {}
    totali[`iva_${v.codice}`] = totali[`iva_${v.codice}`] || {}
    // let t = totali[`iva_${v.aliquota}`]
    let t = totali[`iva_${v.codice}`]
    let importoNetto =  +(v.importoNettoTotale * (1 - scontoPerc)).toFixed(numDecimali)
    let importoOmaggi =  +(v.omaggi * (1 - scontoPerc)).toFixed(numDecimali)
    t.merce = +((t.merce || 0) + importoNetto).toFixed(numDecimali)
    let speseAl = +(importoNetto * cr).toFixed(numDecimali)
    t.spese = +((t.spese || 0) + speseAl).toFixed(numDecimali)
    t.imponibile = +((t.imponibile || 0) + importoNetto + speseAl).toFixed(numDecimali)
    // t.iva = +((t.iva || 0) + v.iva).toFixed(numDecimali)
    let iva = +(v.aliquota * (importoNetto + speseAl + importoOmaggi) / 100).toFixed(numDecimali)
    t.ivaCodice = v.codice
    t.iva = +((t.iva || 0) + iva).toFixed(numDecimali)
    t.ivaOmaggi = +((t.ivaOmaggi || 0) + arrotonda(v.aliquota * (importoOmaggi) / 100)).toFixed(numDecimali)
    t.importoOmaggi = +importoOmaggi.toFixed(numDecimali)    
    // t.importo = +((t.importo || 0) + v.importoTotale).toFixed(numDecimali)
    t.importo = +((t.importo || 0) + (importoNetto + speseAl) + iva).toFixed(numDecimali)
    t.aliquota = String(v.aliquota) // TODO: Verificare esenzioni ?
    t.quantita = (t.quantita || 0) + v.quantita

    totali['generale'] = totali['generale'] || {}
    let tg = totali['generale']
    tg.imponibile = +((tg.imponibile || 0) + (importoNetto + speseAl)).toFixed(numDecimali)
    // tg.nettoMerce = +((tg.nettoMerce || 0) + v.importoNettoTotale).toFixed(numDecimali) 
    tg.nettoMerce = +((tg.nettoMerce || 0) + importoNetto).toFixed(numDecimali)
    tg.totaleMerce = +((tg.totaleMerce || 0) + v.importoNettoTotale).toFixed(numDecimali)
    tg.spese = +((tg.spese || 0) + speseAl).toFixed(numDecimali)
    tg.iva = +((tg.iva || 0) + iva).toFixed(numDecimali)
    tg.importo = +((tg.importo || 0) + (importoNetto + speseAl) + iva).toFixed(numDecimali)
    tg.quantita = (tg.quantita || 0) + v.quantita
  }
  if (totSpeseD > 0) {
    totali[`iva_N1`] = totali[`iva_N1`] || {}
    let t = totali[`iva_N1`]
    t.imponibile = +((t.imponibile || 0) + totSpeseD).toFixed(numDecimali)
    t.iva = 0
    t.ivaOmaggi = 0
    t.importo = t.imponibile
    t.ivaCodice = 'N1'
    t.aliquota = 0
    t.quantita = 1
    t.spese = +((t.spese || 0) + totSpeseD).toFixed(numDecimali)
    t.merce = t.merce || 0
    totali.generale.spese = +(totali.generale.spese + t.spese).toFixed(numDecimali)
  }
  totali.generale.imponibile = +(totali.generale.imponibile + totSpeseD).toFixed(numDecimali)
  totali.generale.importo = +(totali.generale.importo + totSpeseD).toFixed(numDecimali)
  totali.generale.speseDocumentate = +(totSpeseD).toFixed(numDecimali)

  //TODO: Verificare. Inserisco calcolo seguente per problemi di arrotondamento ricalcolo iva e totale da imponibile per ogni aliquota
  // Può essere evitato se si sommano i totali delle ddt
  // Tiene conto anche degli omaggi con rivalsa

  let totaleIva = 0
  let totaleImporto = 0

  for (let item of Object.keys(totali).filter(x => x !== 'generale')) {
    let al = totali[item]
    al.iva = +(al.imponibile * parseFloat(al.aliquota) / 100).toFixed(numDecimali)
    totaleIva += (al.iva + al.ivaOmaggi)
    al.importo = +(al.imponibile + al.iva + al.ivaOmaggi).toFixed(numDecimali)
    totaleImporto += al.importo
  }
  totali.generale.iva = totaleIva
  totali.generale.importo = +totaleImporto.toFixed(numDecimali)

  for (let item of Object.keys(totali).filter(x => x !== 'generale')) {
    let al = totali[item]
    al.imponibile = +al.imponibile.toFixed(2)
    al.importo = +al.importo.toFixed(2)
    al.iva = +al.iva.toFixed(2)
    al.merce = +al.merce.toFixed(2)
  }
  totali.generale.imponibile = +totali.generale.imponibile.toFixed(2)
  totali.generale.importo = +totali.generale.importo.toFixed(2)
  totali.generale.iva = +totali.generale.iva.toFixed(2)
  totali.generale.nettoMerce = +totali.generale.nettoMerce.toFixed(2)
  totali.generale.totaleMerce = +totali.generale.totaleMerce.toFixed(2)
  return totali
}

function calcolaValoriDocumento(ddt, repartiStatistica) {
  const rr = ddt.righe.filter(x => x.aliquotaIva)
  let aliquote = rr.map(x => _.omit(x.aliquotaIva, 'stampante'))
  // let repartiUsati = _.uniq(rr.map(x => x.repartoFiscale))
  aliquote = _.uniqBy(aliquote, 'codice')
  const valori = []
  //for (let rp of repartiStatistica.filter(x => repartiUsati.includes(x.repartoFiscale))) { // aliquote
  for (let al of aliquote.filter(x => !_.isEmpty(x))) { // aliquote
    al.aliquota = al.valore
    const qta = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.quantita || 0) })
    const vl = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoTotale) })
    
    let valore = {
      quantita: qta
    }
    valore.prezzoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoUnitario) })
    valore.prezzoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoTotale) })
    // valore.prezzoTotale = +(valore.prezzoUnitario * valore.quantita).toFixed(numDecimali)
    
    valore.prezzoNettoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoNettoUnitario) })
    valore.prezzoNettoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoNettoTotale) })
    // valore.prezzoNettoTotale = +(valore.prezzoNettoUnitario * valore.quantita).toFixed(numDecimali)

    valore.importoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoUnitario) })
    valore.importoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoTotale) })
    // valore.importoTotale = +(valore.importoUnitario * valore.quantita).toFixed(numDecimali)
    valore.importoNettoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoNettoUnitario) })
    valore.importoNettoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return el.omaggio ? 0 : parseFloat(el.valore.importoNettoTotale) })
    valore.omaggi = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return el.omaggio ? parseFloat(el.valore.importoNettoTotale) : 0 })
    // valore.importoNettoTotale = +(valore.importoNettoUnitario * valore.quantita).toFixed(numDecimali)
    valore.iva = +(valore.importoTotale - valore.importoNettoTotale - valore.omaggi).toFixed(numDecimali)
    valore.sconto = +(valore.prezzoTotale - valore.importoTotale).toFixed(numDecimali)

    valore = { ...valore, ...al }
    valori.push(valore)
  }
  
  return valori
}

function calcolaScadenze(totali, pagamento) {
  const scadenze = []
  var scadenza
  if (!pagamento) {
    scadenza = { data: moment().format('DD/MM/YYYY'), importo: +totali.generale.importo.toFixed(2) }
    scadenze.push(scadenza)
  } else {
    if (!pagamento.giorniPagamento) {
      if (!pagamento.dataPagamento || pagamento.dataPagamento === 'DF') {
        scadenza = { data: moment().format('DD/MM/YYYY'), importo: +totali.generale.importo.toFixed(2) }
      } else {
        scadenza = { data: moment().endOf('mounth').format('DD/MM/YYYY'), importo: +totali.generale.importo.toFixed(2) }
      }
      scadenze.push(scadenza)
    } else {
      let numeroPagamenti = pagamento.giorniPagamento.length
      let importoScadenza = +(totali.generale.importo / numeroPagamenti).toFixed(numDecimali)
      let acc = 0
      for (let i = 0; i < numeroPagamenti; i++) {
        if (i === numeroPagamenti - 1) {
          importoScadenza = +(totali.generale.importo - acc).toFixed(numDecimali)
        }
        acc += importoScadenza
        importoScadenza = +importoScadenza.toFixed(2)
        // TODO: Verificare. Probabilemente 30gg, 60gg, etc vanno cambiati con 1 mese, 2 mesi, etc, altrimenti problemi con date particolari. Es 01/09 30gg e 60gg FM vanno entrambi al 31/10
        let dataScadenza = pagamento.dataPagamento === 'DF' ? moment().add(pagamento.giorniPagamento[i], 'day') : moment().add(pagamento.giorniPagamento[i], 'day').endOf('month')
        scadenza = { data: dataScadenza.format('DD/MM/YYYY'), importo: importoScadenza }
        scadenze.push(scadenza)
      }
    }
  }
  return scadenze
}

function calcolaSpese(speseFattura, importo, totale) {
  const spese = []
  var valore
  var totaleSpese = 0
  for (let sp of speseFattura) {
    if (!sp.tipo || sp.tipo === 'IMPORTO') {
      valore = +parseFloat(sp.valore || 0).toFixed(numDecimali)
    }
    if (sp.tipo === 'PERCENTUALE') {
      valore = +(parseFloat(sp.valore || 0) * importo / 100).toFixed(numDecimali)
    }
    // totaleSpese += +(valore * importo / totale).toFixed(numDecimali)   ?????
    totaleSpese += valore
    spese.push({ codice: sp.codice, descrizione: sp.descrizione, valore: valore, documentate: sp.documentate })
  }
  return { spese, totaleSpese: +totaleSpese.toFixed(numDecimali) }
}

export default {
  parseOrdineWH,
  parseOrdineWC,
  verificaClienteWC,
  inviaOrdinePark,
  wcCreaOrdineEC
}
